import Active from './Active'
import Closed from './Closed'
import Details from './Details'


export default { Active, Closed, Details }